/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OnlineState {
    Offline = 0,
    Online = 1,
    Away = 2,
    DoNotDisturb = 3,
}
